import {
    Box,
    Container,
    useDisclosure,
} from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import RecentCases from '../../components/modals/RecentCases';
import CaseModal from '../../components/modals/CaseModal';
import Marquee from "../../components/modals/Marquee";
import { motion } from "framer-motion";
import icon from "../../assets/images/legalLogo.jpg";
import HttpRequest from '../../core/services/api/httpRequest';

const WorksPage = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [selectedCase, setSelectedCase] = useState(null);
    const [cases, setCases] = useState([]);

    const MotionBox = motion(Box);

    const handleCaseClick = (caseItem) => {
        setSelectedCase(caseItem);
        onOpen();
    };

    const structuredData = {
        "@context": "https://schema.org",
        "@type": "LegalService",
        "name": "LegalTitan",
        "url": "https://legaltitan.am/services",
        "logo": "https://legaltitan.am/assets/images/legalLogo.jpg",
        "description": "Պրոֆեսիոնալ իրավաբանական և փաստաբանական ծառայություններ Հայաստանում LegalTitan-ից։",
    };

    useEffect(() => {
        const fetchCases = async () => {
            try {
                const response = await HttpRequest().get("case-work");
                if (response.data && response.data.length) {
                    setCases(response.data);
                }
            } catch (error) {
                console.error("Failed to fetch cases:", error);
            }
        };
        fetchCases();
    }, []);

    return (
        <Box>
            <Marquee
                icon={icon}
                title="Ձեր Իրավունքի պաշտպանությունը մեր առաքելությունն է։"
                subtitle=""
                bgColor="#1a365d"
                speed={10}
                py={{ base: 4, md: 6 }}
                fontSize={{ base: "sm", md: "md" }}
            />
            <MotionBox
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
            >
                <Container
                    maxW={{ base: "95%", md: "container.lg", xl: "container.xl" }}
                    py={{ base: 10, md: 20 }}
                >
                    <RecentCases cases={cases} onCaseClick={handleCaseClick} />
                </Container>

                <CaseModal
                    isOpen={isOpen}
                    onClose={onClose}
                    caseData={selectedCase}
                />
            </MotionBox>
        </Box>
    );
};

export default WorksPage;
